import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';

export default function AutoCompleteMultiple(props) {
  const {
    options = [],
    label = '',
    getLabel = (item) => item?.label || '',
    value: propValue = [],
    onChange,
    multiple = false,
  } = props;

  const [value, setValue] = useState(multiple ? [] : null);

  useEffect(() => {
    setValue(propValue || (multiple ? [] : null));
  }, [propValue, multiple]);

  return (
    <div style={{ width: props.width || '30%', minWidth: props.width || '20%', paddingRight: '10px', paddingBottom: '2px' }}>
      <Autocomplete
        {...{width: props.width, disabled: props.disabled, disableClearable: props.disableClearable, style: props.inputStyle ? props.inputStyle(value || {}) : {}}}
        multiple={multiple}
        options={options}
        value={value}
        getOptionLabel={getLabel}
        onChange={(event, newValue) => {
          setValue(newValue);
          if (onChange) onChange(newValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="standard"
          />
        )}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
      />
    </div>
  );
}
